import { render, staticRenderFns } from "./MyApplication.vue?vue&type=template&id=b580b7e8&scoped=true&"
import script from "./MyApplication.vue?vue&type=script&lang=js&"
export * from "./MyApplication.vue?vue&type=script&lang=js&"
import style0 from "./MyApplication.vue?vue&type=style&index=0&id=b580b7e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b580b7e8",
  null
  
)

export default component.exports